'user strict';
angular.module('schoolLinqApp').factory('schoolNutritionService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/schoolnutrition';

		function getSchoolNutritionFiscalYears() {
			return $http.get(endpoint + '/getSchoolNutritionFiscalYears');
		}

		function getSchoolNutritionSites(fiscalyear) {
			return $http.get(endpoint + '/getSchoolNutritionSites', {
				params: { fiscalyear: fiscalyear },
			});
		}

		return {
			getSchoolNutritionFiscalYears: getSchoolNutritionFiscalYears,
			getSchoolNutritionSites: getSchoolNutritionSites,
		};
	},
]);
